module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/92/assets/images/77f651e9ceade21d357055660c7fe8ba.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/badges/Diamond/Diamond1.svg
// module id = WZai
// module chunks = 1